import { WalletSelectors } from "@capone/checkout";
import { ActivityMachineContext } from "../modules/book/state/types";

/**
 * Converts encrypted properties from various formats into a unified string array
 *
 * @param encryptedProperties - Encrypted properties in string, array, or undefined format
 * @returns A string array of encrypted properties, or empty array if none exist
 */
export function handleEncryptedProperties(
  encryptedProperties: string[] | string | undefined | null
): string[] {
  if (Array.isArray(encryptedProperties)) {
    if (encryptedProperties.length > 0 && encryptedProperties[0] !== "") {
      return encryptedProperties;
    }
    return [];
  }

  if (encryptedProperties) {
    return [encryptedProperties];
  }

  return [];
}

/**
 * Extracts all encrypted properties from the state machine context
 *
 * @param context - The experiences machine context
 * @returns A combined array of all encrypted properties from all sources
 */
export function getAdditionalEncryptedProperties(
  context: ActivityMachineContext
): string[] {
  const {
    activityShop,
    shopOptionTrackingProperties,
    activityDetailsTrackingProperties,
  } = context;

  const selectedOffer = WalletSelectors.getSelectedOffer({ context });
  const creditToApply = WalletSelectors.getTravelWalletCreditToApply({
    context,
  });

  return [
    ...handleEncryptedProperties(
      activityShop?.trackingProperties?.encryptedProperties
    ),
    ...handleEncryptedProperties(
      shopOptionTrackingProperties?.encryptedProperties
    ),
    ...handleEncryptedProperties(
      activityDetailsTrackingProperties?.encryptedProperties
    ),
    ...handleEncryptedProperties(
      selectedOffer?.trackingPropertiesV2?.encryptedProperties
    ),
    ...handleEncryptedProperties(
      creditToApply?.trackingPropertiesV2?.encryptedProperties
    ),
  ];
}
